import { formatDateLocal } from "../../../lib/script"

import classes from './ObjectCell.module.css'
import classesCell from './BodyCell.module.css'
import { useWorkQShell, WorkQHoverHint } from "../context/workQShellContext";
import WorkQDeferredTooltip from "./WorkQDeferredTooltip";

export default function ObjectCell({data, label}) {

    const shell = useWorkQShell()

    if (label == 'last_activity') {

        let messageHTML = data ? <div className={`${classes.message}`}>
            <div className={classes.message_inner}>
                <div>{formatDateLocal(data?.activity_date)} </div>
                <div dangerouslySetInnerHTML={{__html: data.message}}></div>
                <div>by <strong>{data.user?.name}</strong></div>
            </div>
        </div> : null

        const cellInner = (
            <div className={`${classes.object_cell} ${classesCell.body_cell}`}>
                {data && <div >
                    {formatDateLocal(data?.activity_date)}                         
                </div>}
            </div>
        )

        if (shell) {
            return (
                <WorkQHoverHint message={messageHTML} disabled={!messageHTML} className={classes.wrapper}>
                    {cellInner}
                </WorkQHoverHint>
            )
        }

        return <>
            <WorkQDeferredTooltip mode={'v3'} message={messageHTML} disabled={!messageHTML} wrapperClassName={classes.wrapper}>
                {cellInner}
            </WorkQDeferredTooltip>        
        </> 
            
    }

    return <div className={`${classes.object_cell} ${classesCell.body_cell}`}>

    </div>
}
